/* ChroMorpher - Meta landing page. Self-contained. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cmlp]');
  if (!root) return;

  var CFG = JSON.parse(root.getAttribute('data-cmlp-config') || '{}');

  /* Universal DIY products, rendered from live Shopify data by the section template.
     These are NOT fitment matches - they are shown as a clearly separate alternative. */
  var DIY = [];
  (function () {
    var el = document.getElementById('cmlp-diy-data');
    if (!el) return;
    try { DIY = JSON.parse(el.textContent || '[]') || []; } catch (e) { DIY = []; }
    DIY = DIY.filter(function (d) { return d && d.title && d.url && d.available; });
  })();

  /* Products whose handle predates the current catalogue naming and are not in the
     fitment map. Values: [make, model, yearFrom, yearTo, typeIndex]. */
  var EXTRA = {
    'window-trim-for-2024-2026-toyota-tacoma-double-cab-versions-chrome-plated-decorative-for-protection-and-car-accessories': ['Toyota', 'Tacoma', 2024, 2026, 1]
  };

  var YEAR_MAX = 2027, YEAR_MIN = 1998;
  var RE_RANGE = /(19|20)[0-9]{2}[ ]*-[ ]*((19|20)[0-9]{2})/;
  var RE_OPEN = /((19|20)[0-9]{2})[ ]*-[ ]*(?![0-9])/;
  var RE_ONE = /[(]((19|20)[0-9]{2})[)]?/;
  var RE_NONDIGIT = /[^0-9]/g;
  var RE_DARK = /black|titanium|carbon|graphite|shadow/i;
  var RE_LIGHT = /silver|chrome/i;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : '$' + n.toFixed(2) + ' USD'; }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/["]/g, '&quot;').replace(/[']/g, '&#39;');
  }
  function stars(r) { var f = Math.round(r); return '★★★★★'.slice(0, f) + '☆☆☆☆☆'.slice(0, 5 - f); }
  function fnv(s) {
    var h = 0x811c9dc5;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return h.toString(36);
  }

  function parseYears(title) {
    var t = String(title || '').replace(/–|—/g, '-');
    var m = t.match(RE_RANGE);
    if (m) { var p = m[0].split('-'); var a = parseInt(p[0], 10), b = parseInt(p[1], 10); if (b >= a) return { a: a, b: b }; }
    var o = t.match(RE_OPEN);
    if (o) return { a: parseInt(o[1], 10), b: YEAR_MAX };
    var one = t.match(RE_ONE);
    if (one) { var y = parseInt(one[0].replace(RE_NONDIGIT, ''), 10); if (y >= YEAR_MIN && y <= YEAR_MAX) return { a: y, b: y }; }
    return null;
  }

  var TYPES = ['precut', 'steel', 'abs', 'other'];
  var TYPE_LABEL = { precut: 'Precut vinyl', steel: 'Stainless steel molding', abs: 'ABS molding', other: 'Trim accessory' };
  var TYPE_TIME = { precut: '30-60 min', steel: '10-15 min', abs: '10-15 min', other: '' };
  var TYPE_ORDER = { precut: 0, steel: 1, abs: 2, other: 3 };

  var INDEX = [], BY_MAKE = {}, ready = false;

  function build(products, data) {
    var K = data.K || [], M = data.M || [], P = data.P || {};
    products.forEach(function (p) {
      var make, model, mapA = 0, mapB = 0, typeIdx = 0, rating = null, count = null;
      var extra = EXTRA[p.handle];
      if (extra) {
        make = extra[0]; model = extra[1]; mapA = extra[2]; mapB = extra[3]; typeIdx = extra[4];
      } else {
        var row = P[fnv(p.handle)];
        if (!row) return;
        var f = row.split(',');
        make = K[+f[0]]; model = M[+f[1]];
        mapA = +f[2] || 0; mapB = +f[3] || 0; typeIdx = +f[4] || 0;
        rating = parseFloat(f[5]) || null; count = parseInt(f[6], 10) || null;
      }
      if (!make || !model) return;

      var yr = parseYears(p.title);
      var a = yr ? yr.a : mapA;
      var b = yr ? yr.b : mapB;
      if (a && !b) b = a;

      var vars = (p.variants || []).map(function (v) {
        var t = String(v.title || '');
        var dark = RE_DARK.test(t);
        return {
          id: v.id, title: v.title, price: v.price, cap: v.compare_at_price,
          ok: v.available !== false, dark: dark, light: !dark && RE_LIGHT.test(t)
        };
      });
      if (!vars.length) return;

      var sellable = vars.filter(function (v) { return v.ok; });
      var pool = sellable.length ? sellable : vars;
      var lightOnly = pool.some(function (v) { return v.light; }) && !pool.some(function (v) { return v.dark; });
      var prices = pool.map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
      var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || p.featured_image || '';

      INDEX.push({
        handle: p.handle, title: p.title, make: make, model: model,
        a: a || null, b: b || null, type: TYPES[typeIdx] || 'precut',
        img: img, vars: vars, lightOnly: lightOnly,
        min: prices.length ? Math.min.apply(null, prices) : null,
        r: rating, n: count, any: sellable.length > 0
      });
    });
    INDEX.forEach(function (it) {
      BY_MAKE[it.make] = BY_MAKE[it.make] || {};
      (BY_MAKE[it.make][it.model] = BY_MAKE[it.make][it.model] || []).push(it);
    });
    ready = true;
  }

  var selMake = $('#cmlp-make'), selModel = $('#cmlp-model'), selYear = $('#cmlp-year');
  var out = $('#cmlp-result'), resetBtn = $('#cmlp-reset');

  function opt(v, l) { var o = document.createElement('option'); o.value = v; o.textContent = l; return o; }
  function fill(sel, list, placeholder) {
    sel.innerHTML = '';
    sel.appendChild(opt('', placeholder));
    list.forEach(function (v) { sel.appendChild(opt(v, v)); });
  }
  function initSelects() {
    var makes = Object.keys(BY_MAKE).sort();
    fill(selMake, makes, 'Select make');
    selMake.disabled = false;
    var mn = $('#cmlp-makecount');
    if (mn) mn.textContent = String(makes.length);
  }

  selMake && selMake.addEventListener('change', function () {
    var mk = selMake.value;
    fill(selYear, [], 'Select model first'); selYear.disabled = true;
    if (!mk) { fill(selModel, [], 'Select make first'); selModel.disabled = true; render(); return; }
    fill(selModel, Object.keys(BY_MAKE[mk]).sort(), 'Select model');
    selModel.disabled = false;
    render();
  });
  selModel && selModel.addEventListener('change', function () {
    if (!selModel.value) { fill(selYear, [], 'Select model first'); selYear.disabled = true; render(); return; }
    var years = [];
    for (var y = YEAR_MAX; y >= YEAR_MIN; y--) years.push(String(y));
    fill(selYear, years, 'Select year');
    selYear.disabled = false;
    render();
  });
  selYear && selYear.addEventListener('change', render);
  resetBtn && resetBtn.addEventListener('click', function () {
    selMake.value = '';
    fill(selModel, [], 'Select make first'); selModel.disabled = true;
    fill(selYear, [], 'Select model first'); selYear.disabled = true;
    render();
    selMake.focus();
  });

  var ICON_OK = '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="currentColor" opacity=".16"/><path d="M6 10.4l2.6 2.6L14.2 7.4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_WARN = '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="currentColor" opacity=".16"/><path d="M10 5.6v5.2" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/><circle cx="10" cy="14.2" r="1.05" fill="currentColor"/></svg>';

  function coveredRanges(items) {
    var rs = items.filter(function (i) { return i.a; }).map(function (i) { return i.a === i.b ? String(i.a) : i.a + '-' + i.b; });
    return rs.filter(function (v, i) { return rs.indexOf(v) === i; }).sort();
  }

  function pickDefault(it) {
    var sellable = it.vars.filter(function (v) { return v.ok; });
    var pool = sellable.length ? sellable : it.vars;
    var dark = pool.filter(function (v) { return v.dark; })[0];
    return dark || pool[0];
  }

  function kitCard(it, best, year) {
    var v0 = pickDefault(it);
    var fit = it.a ? (it.a === it.b ? String(it.a) : it.a + '-' + it.b) : null;
    var h = '<article class="cmlp__kit' + (best ? ' cmlp__kit--best' : '') + '">';
    if (best) h += '<div class="cmlp__kit-flag">Best match for your ' + esc((year ? year + ' ' : '') + it.model) + '</div>';
    h += '<div class="cmlp__kit-top"><div class="cmlp__kit-img">';
    if (it.img) h += '<img src="' + esc(it.img) + '" alt="' + esc(it.title) + '" loading="lazy" width="104" height="104">';
    h += '</div><div class="cmlp__kit-meta">';
    h += '<span class="cmlp__badge' + (it.type === 'precut' ? ' cmlp__badge--precut' : '') + '">' + esc(TYPE_LABEL[it.type]) + '</span>';
    h += '<h3 class="cmlp__kit-title">' + esc(it.title) + '</h3>';
    h += '<p class="cmlp__kit-fit">' + (fit ? 'Fits ' + esc(fit) : 'Fitment years not listed - confirm before ordering') + '</p>';
    if (it.lightOnly) h += '<p class="cmlp__kit-note">Chrome / silver finish - this one is polished trim, not a blackout kit.</p>';
    if (it.r && it.n) h += '<p class="cmlp__kit-rating"><span aria-hidden="true">' + stars(it.r) + '</span> <b>' + it.r.toFixed(2) + '</b> from ' + it.n + ' reviews</p>';
    h += '<p class="cmlp__kit-price">' + money(v0.price);
    if (v0.cap && parseFloat(v0.cap) > parseFloat(v0.price)) h += '<span class="cmlp__kit-was">' + money(v0.cap) + '</span>';
    h += '</p></div></div><div class="cmlp__kit-bottom">';
    if (TYPE_TIME[it.type]) {
      h += '<p class="cmlp__kit-specs"><span>Typical install ' + TYPE_TIME[it.type] + '</span><span>Free shipping</span>';
      if (it.type === 'precut') h += '<span>Free Pro Tool Kit included</span><span>Precut fit promise</span>';
      h += '</p>';
    }
    if (it.vars.length > 1) {
      h += '<div class="cmlp__variants" role="group" aria-label="Choose an option">';
      it.vars.forEach(function (v) {
        h += '<button type="button" class="cmlp__vpill" data-vid="' + v.id + '" data-price="' + esc(v.price) + '" aria-pressed="' + (v === v0 ? 'true' : 'false') + '"' + (v.ok ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
      });
      h += '</div>';
    }
    h += '<button type="button" class="cmlp__btn" data-add="' + v0.id + '"' + (it.any ? '' : ' disabled') + '>' + (it.any ? 'Add to cart - ' + money(v0.price) : 'Currently unavailable') + '</button>';
    h += '<a class="cmlp__kit-link" href="/products/' + esc(it.handle) + '">See full details and photos</a>';
    h += '</div></article>';
    return h;
  }

  /* ---- Universal DIY alternative -------------------------------------------------
     Never rendered as a fitment match. Compact ghost cards under the matched kits,
     promoted to a bordered lead block when nothing vehicle-specific exists.        */

  function diyCard(d, lead) {
    var cls = 'cmlp__btn cmlp__btn--sm' + (lead ? '' : ' cmlp__btn--ghost');
    var h = '<article class="cmlp__diyc">';
    h += '<div class="cmlp__diyc-img">';
    if (d.img) h += '<img src="' + esc(d.img) + '" alt="' + esc(d.title) + '" loading="lazy" width="160" height="160">';
    h += '</div><div class="cmlp__diyc-b">';
    h += '<h4 class="cmlp__diyc-t">' + esc(d.title) + '</h4>';
    h += '<p class="cmlp__diyc-p">' + (d.varies ? 'From ' + esc(d.priceMin) : esc(d.price)) + '</p>';
    if (d.nvars > 1) {
      h += '<a class="' + cls + '" href="' + esc(d.url) + '">Choose options</a>';
    } else {
      h += '<button type="button" class="' + cls + '" data-add="' + esc(d.vid) + '">Add to cart</button>';
    }
    h += '</div></article>';
    return h;
  }

  function diyPanel(opts) {
    if (!DIY.length) return '';
    opts = opts || {};
    var lead = !!opts.lead;
    var v = opts.vehicle ? esc(opts.vehicle) : '';
    var h = '<section class="cmlp__diy' + (lead ? ' cmlp__diy--lead' : '') + '" aria-label="Universal DIY alternative">';
    h += '<div class="cmlp__diy-head">';
    h += '<span class="cmlp__diy-tag">Universal DIY &middot; works on any vehicle</span>';
    if (lead) {
      h += '<h3 class="cmlp__diy-title">No vehicle-specific kit yet? You can still black it out.</h3>';
      h += '<p class="cmlp__diy-sub">ChroMorpher universal vinyl goes onto the chrome trim your car already has, so no model-specific precut kit is needed. You cut it to your own trim line'
        + (v ? ' &mdash; which works on a ' + v + ' exactly as it does on any other car' : '')
        + '. Same material and finish as our precut kits.</p>';
    } else {
      h += '<h3 class="cmlp__diy-title">Or go DIY &mdash; works on any vehicle</h3>';
      h += '<p class="cmlp__diy-sub">No vehicle-specific kit needed. Wrap the chrome yourself with universal ChroMorpher vinyl. <b>'
        + (v ? 'These are universal products, not precut for your ' + v + '.' : 'These are universal products, not precut for a specific vehicle.')
        + '</b> You trim them to your own trim line.</p>';
    }
    h += '</div><div class="cmlp__diys">' + DIY.map(function (d) { return diyCard(d, lead); }).join('') + '</div>';
    h += '</section>';
    return h;
  }

  function render() {
    if (!out) return;
    var mk = selMake.value, md = selModel.value, yr = selYear.value ? parseInt(selYear.value, 10) : null;
    if (resetBtn) resetBtn.hidden = !mk;
    if (!ready || !mk || !md) { out.innerHTML = ''; return; }

    var items = (BY_MAKE[mk] && BY_MAKE[mk][md]) ? BY_MAKE[mk][md].slice() : [];
    items.sort(function (x, y) {
      return (x.lightOnly - y.lightOnly) || (TYPE_ORDER[x.type] - TYPE_ORDER[y.type]) || (x.min - y.min);
    });
    var html = '';
    var vehicle = yr ? (yr + ' ' + mk + ' ' + md) : (mk + ' ' + md);

    if (!yr) {
      html += '<div class="cmlp__state cmlp__state--warn"><p class="cmlp__state-title">' + ICON_WARN + '<span>Pick your year</span></p>';
      html += '<p>Kits are made per generation, so the year decides which one fits. For the ' + esc(md) + ' we cover ' + esc(coveredRanges(items).join(', ') || 'selected years') + '.</p></div>';
      out.innerHTML = html;
      return;
    }

    var exact = items.filter(function (i) { return i.a && yr >= i.a && yr <= i.b; });
    var unknown = items.filter(function (i) { return !i.a; });
    var blackout = exact.filter(function (i) { return !i.lightOnly; });

    if (exact.length) {
      html += '<div class="cmlp__state cmlp__state--ok"><p class="cmlp__state-title">' + ICON_OK + '<span>' + exact.length + (exact.length > 1 ? ' kits fit' : ' kit fits') + ' your ' + esc(vehicle) + '</span></p>';
      if (blackout.length > 1) html += '<p class="cmlp__covered">Two ways to do it: precut vinyl is the cheaper DIY route, stainless steel clips over the trim and goes on faster.</p>';
      else if (!blackout.length) html += '<p class="cmlp__covered">Heads up - what we list for this vehicle is polished chrome or silver trim rather than a blackout kit. For a blacked-out look, the universal vinyl below fits any car.</p>';
      html += '</div><div class="cmlp__kits">' + exact.map(function (it, i) { return kitCard(it, i === 0 && exact.length > 1 && !it.lightOnly, yr); }).join('') + '</div>';
      if (unknown.length) {
        html += '<p class="cmlp__finder-note" style="margin-top:14px">Also listed for the ' + esc(md) + ', without published fitment years:</p>';
        html += '<div class="cmlp__kits">' + unknown.map(function (it) { return kitCard(it, false, null); }).join('') + '</div>';
      }
      html += diyPanel({ vehicle: vehicle });
    } else if (unknown.length) {
      html += '<div class="cmlp__state cmlp__state--warn"><p class="cmlp__state-title">' + ICON_WARN + '<span>We list ' + esc(md) + ' kits, but not their fitment years</span></p>';
      html += '<p>Message us with your exact year before ordering and we will confirm the fit, or take the universal DIY route below, which fits any vehicle.</p>';
      html += '<div class="cmlp__btnrow" style="margin-top:6px"><a class="cmlp__btn cmlp__btn--sm cmlp__btn--ghost" href="' + esc(CFG.contact) + '">Ask us about my ' + esc(md) + '</a></div></div>';
      html += '<div class="cmlp__kits">' + unknown.map(function (it) { return kitCard(it, false, null); }).join('') + '</div>';
      html += diyPanel({ vehicle: vehicle });
    } else {
      var covered = coveredRanges(items).join(', ');
      html += '<div class="cmlp__state cmlp__state--warn"><p class="cmlp__state-title">' + ICON_WARN + '<span>No precut kit for a ' + esc(yr + ' ' + md) + ' yet</span></p>';
      html += '<p>' + (covered
        ? 'For the ' + esc(md) + ' we currently cover ' + esc(covered) + '. Yours is not one of them, so nothing precut here is guaranteed to fit.'
        : 'We do not have published fitment for the ' + esc(md) + ' in that year, so nothing precut here is guaranteed to fit.') + '</p></div>';
      html += diyPanel({ lead: true, vehicle: vehicle });
      html += '<div class="cmlp__diy-alt"><p>Set on a kit cut for your exact car? Tell us the vehicle and we will look at adding it.</p>';
      html += '<a class="cmlp__btn cmlp__btn--sm cmlp__btn--ghost" href="' + esc(CFG.contact) + '">Ask us to make my ' + esc(yr + ' ' + md) + '</a></div>';
    }
    out.innerHTML = html;
  }

  root.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var pill = e.target.closest('.cmlp__vpill');
    if (pill && !pill.disabled) {
      var card = pill.closest('.cmlp__kit') || pill.closest('.cmlp__path');
      $$('.cmlp__vpill', card).forEach(function (p) { p.setAttribute('aria-pressed', String(p === pill)); });
      var btn = card.querySelector('[data-add]');
      if (btn) {
        btn.setAttribute('data-add', pill.getAttribute('data-vid'));
        if (!btn.disabled) btn.textContent = 'Add to cart - ' + money(pill.getAttribute('data-price'));
      }
      return;
    }
    var jump = e.target.closest('[data-jump]');
    if (jump) {
      e.preventDefault();
      var t = document.querySelector(jump.getAttribute('href'));
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var uni = $('#cmlp-path-universal');
      if (uni) { uni.style.boxShadow = '0 0 0 3px #121212'; setTimeout(function () { uni.style.boxShadow = ''; }, 2200); }
      return;
    }
    var add = e.target.closest('[data-add]');
    if (add && !add.disabled) addToCart(add);
  });

  var toast = $('#cmlp-toast'), toastT;
  function showToast(title, sub) {
    if (!toast) return;
    $('#cmlp-toast-title').textContent = title;
    $('#cmlp-toast-sub').textContent = sub || '';
    toast.setAttribute('data-show', 'true');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.setAttribute('data-show', 'false'); }, 6000);
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-add');
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.disabled = false; btn.textContent = label;
        if (!res.ok) { showToast('Could not add that', (res.j && res.j.description) || 'Please try again.'); return; }
        var it = (res.j.items && res.j.items[0]) || res.j;
        showToast('Added to cart', (it && it.product_title ? it.product_title : '') + ' - use code NEEDIT for 10% off');
        closeDrawer();
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var n = $('#cmlp-sticky-count');
          if (n) n.textContent = c.item_count + (c.item_count === 1 ? ' item' : ' items') + ' in cart';
        });
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
        showToast('Could not add that', 'Check your connection and try again.');
      });
  }

  var sticky = $('#cmlp-sticky'), scrim = $('#cmlp-scrim'), drawer = $('#cmlp-drawer');
  var anchor = $('#cmlp-paths');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      sticky.setAttribute('data-show', es[0].boundingClientRect.top < 0 ? 'true' : 'false');
    }, { threshold: 0 }).observe(anchor);
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false; scrim.hidden = false;
    void drawer.offsetHeight;
    drawer.setAttribute('data-open', 'true');
    scrim.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var f = drawer.querySelector('button, a');
    if (f) f.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.setAttribute('data-open', 'false'); scrim.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, 260);
  }
  $$('[data-open-drawer]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
  $$('[data-close-drawer]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  scrim && scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  $$('[data-tabs]').forEach(function (group) {
    var tabs = $$('[role="tab"]', group);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (o) {
          var on = o === t;
          o.setAttribute('aria-selected', String(on));
          var panel = document.getElementById(o.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  });

  $$('a[href^="#cmlp-"]').forEach(function (a) {
    if (a.hasAttribute('data-jump')) return;
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* Demo strip: drop any tile whose image is missing so the band never renders broken. */
  (function () {
    var section = $('#cmlp-demo-section');
    if (!section) return;
    var items = $$('.cmlp__gal-item', section);
    var alive = items.length;
    function drop(item) {
      if (!item.parentNode) return;
      item.parentNode.removeChild(item);
      alive--;
      if (alive <= 0) section.hidden = true;
    }
    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) { drop(item); return; }
      if (img.complete && img.naturalWidth === 0) { drop(item); return; }
      img.addEventListener('error', function () { drop(item); });
    });
  })();

  var status = $('#cmlp-finder-status');
  Promise.all([
    fetch(CFG.productsUrl, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
    fetch(CFG.fitmentUrl, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
  ]).then(function (res) {
    build(res[0].products || [], res[1] || {});
    initSelects();
    if (status) status.hidden = true;
    render();
    root.setAttribute('data-cmlp-ready', 'true');
  }).catch(function (err) {
    if (status) { status.hidden = false; status.textContent = 'The vehicle finder could not load. You can still use the universal vinyl, which fits any vehicle.'; }
    if (window.console) console.warn('[cmlp] fitment load failed', err);
  });
})();